var WebFont = require("webfontloader");

export default {
  init: function () {
    WebFont.load({
      typekit: {
        id: "nrj7cfs",
      },
      // custom: {
      //   families: ['WildLove Script', 'Domaine Text Test'],
      // },
    });
  },
};
